import {
    RequestKeys,
} from 'app/hooks/useRequest'
import request from 'app/requests/ServiceCenter/ServiceCenter.requests'
import ChangeHistory from 'app/shared-components/ChangeHistory'
import {
    WithId,
} from 'app/types/common.types'

import getColumns from './ServiceCenterChangeHistory.columns'

const labelPrefixForChangedColumn = [
    'ServiceCenterStorage',
    'ServiceCenter',
]
const columns = getColumns(labelPrefixForChangedColumn)

export default function ServiceCenterChangeHistory({
    id,
}: Readonly<WithId<number>>) {
    return (
        <ChangeHistory
            id={id}
            requestKey={RequestKeys.getServiceCenterModifications}
            config={request.modifications}
            configName="ServiceHistoryChangeHistory"
            name="ServiceHistoryChangeHistory"
            labelPrefixForChangedColumn={labelPrefixForChangedColumn}
            columns={columns}
        />
    )
}
